import React from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { createTheme, MuiThemeProvider } from '@material-ui/core'
import './components/background.css'
import { Provider } from 'react-redux'
import store from './store'
import { useDarkMode } from './customHooks/useDarkMode'
import AppBarComponent from './components/Organisms/AppBarComponent'
import { SessionProvider } from './components/Organisms/Authentication Dialog/SessionProvider'
import { QueryClient, QueryClientProvider } from 'react-query'

const queryClient = new QueryClient()

function App() {
  const [theme, toggleDarkMode] = useDarkMode()
  const themeConfig = createTheme(theme)
  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <Provider store={store}>
          <DndProvider backend={HTML5Backend} debugMode>
            <div className='content'>
              <MuiThemeProvider theme={themeConfig}>
                <AppBarComponent
                  theme={theme}
                  themeConfig={themeConfig}
                  toggleDarkMode={toggleDarkMode}
                />
              </MuiThemeProvider>
            </div>
          </DndProvider>
        </Provider>
      </SessionProvider>
    </QueryClientProvider>
  )
}

export default App
